import { EstimateGraphic, LetsGetMovingGraphic } from './styles';

const iconMap = {
  letsgetmoving: LetsGetMovingGraphic,
  estimateicon: EstimateGraphic,
} as const;

export type IconName = keyof typeof iconMap;

interface IconProps {
  iconName: IconName;
}

const Icon = ({ iconName }: IconProps) => {
  const IconComponent = iconMap[iconName];
  return <IconComponent aria-hidden />;
};

export default Icon;
